import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Plus as PlusIcon, Trash2 as Trash2Icon } from 'react-feather'
import { size } from 'lodash'
import { clsx } from 'clsx'
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'

import useStyles from './styles'
import theme from 'theme'

const TextFieldList = ({
  controlName,
  arrayControlName,
  containerTitle = 'Itens adicionados',
  disabled = false,
  endAdornment,
  paperContainerProps = {},
  titleContainerProps = {},
  ...rest
}) => {
  const classes = useStyles()

  const { control, errors, setValue, triggerValidation, getValues, watch } =
    useFormContext()

  const arrayItems = watch(arrayControlName)

  const handleAddItemArray = async () => {
    await triggerValidation(controlName)
    const isValid = !errors?.[controlName]

    if (isValid) {
      const newItem = getValues(controlName)
      const currentArray = getValues(arrayControlName) || []

      const itemExists = currentArray.includes(newItem)

      if (itemExists) setValue(controlName, '')
      else if (newItem) {
        setValue(arrayControlName, [...currentArray, newItem])
        setValue(controlName, '')
      }
    }
  }

  const handleRemoveItemArray = (indexRemoveItem) => {
    const currentArray = getValues(arrayControlName) || []
    const updatedArray = currentArray.filter(
      (_, index) => index !== indexRemoveItem,
    )

    setValue(arrayControlName, updatedArray)
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Controller
        control={control}
        name={controlName}
        as={
          <TextField
            variant="outlined"
            error={!!errors?.[controlName] || !!errors?.[arrayControlName]}
            helperText={
              <>
                {errors?.[controlName]?.message ||
                  errors?.[arrayControlName]?.message}
              </>
            }
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Box
                    display="flex"
                    gridGap={theme.spacing(1)}
                    alignItems="center"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      className={clsx({
                        [classes.buttonError]:
                          !!errors?.[controlName] ||
                          !!errors?.[arrayControlName],
                      })}
                      onClick={handleAddItemArray}
                      disabled={disabled}
                      startIcon={<PlusIcon size={20} />}
                    >
                      Adicionar
                    </Button>
                    {endAdornment}
                  </Box>
                </InputAdornment>
              ),
            }}
            disabled={disabled}
            {...rest}
          />
        }
      />
      <Controller control={control} name={arrayControlName} as={<></>} />
      {size(arrayItems) > 0 && (
        <Paper {...paperContainerProps}>
          <Box
            bgcolor={theme.palette.background.default}
            p={2}
            borderRadius={3}
            {...titleContainerProps}
          >
            <Typography>{containerTitle}</Typography>
          </Box>
          <Box py={2} pl={2}>
            <PerfectScrollbar
              options={{ wheelPropagation: false, useBothWheelAxes: true }}
            >
              <Box
                display="flex"
                flexDirection="column"
                gridGap={theme.spacing(1)}
                pr={2}
                maxHeight={400}
              >
                {arrayItems?.map((item, index) => (
                  <Paper key={index} className={classes.item}>
                    <Tooltip title={item}>
                      <Typography color="secondary" noWrap>
                        {item}
                      </Typography>
                    </Tooltip>
                    <IconButton onClick={() => handleRemoveItemArray(index)}>
                      <Trash2Icon size={20} />
                    </IconButton>
                  </Paper>
                ))}
              </Box>
            </PerfectScrollbar>
          </Box>
        </Paper>
      )}
    </Box>
  )
}

TextFieldList.propTypes = {
  controlName: PropTypes.string.isRequired,
  arrayControlName: PropTypes.string.isRequired,
  containerTitle: PropTypes.string,
  disabled: PropTypes.bool,
  endAdornment: PropTypes.node,
  paperContainerProps: PropTypes.object,
  titleContainerProps: PropTypes.object,
}

export default TextFieldList
